export enum RefinanceGoal {
  CHECK_OPTIONS = 'CHECK_OPTIONS',
  LOWER_PAYMENT = 'LOWER_PAYMENT',
  LOWER_RATE = 'LOWER_RATE',
}
